import React, { createContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const breakpointValues = {
    xs: 0,
    sm: 768,
    md: 992,
    lg: 1200,
    xl: 1400,
    xxl: 1700
};

const breakpointArr = Object.keys(breakpointValues);

const getCurrentBreakpoint = () => (
    breakpointArr.find((breakpoint, index) => {
        const nextBreakpointAmount = breakpointValues[breakpointArr[index + 1]] || Infinity;
        return breakpointValues[breakpoint] <= window.innerWidth && nextBreakpointAmount > window.innerWidth;
    })
);

const useBreakpoint = () => {
    const [breakpoint, setBreakpoint] = useState(getCurrentBreakpoint());
    const handleResize = () => {
        const newBreakpoint = getCurrentBreakpoint();
        if (newBreakpoint !== breakpoint) {
            setBreakpoint(newBreakpoint);
        }
    };
    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [breakpoint]);
    return breakpoint;
};

const BreakpointContext = createContext(null);
const BreakpointsProvider = ({ children }) => {
    const breakpoint = useBreakpoint();
    return (
        <BreakpointContext.Provider value={breakpoint}>
            {children}
        </BreakpointContext.Provider>
    );
};

BreakpointsProvider.propTypes = {
    children: PropTypes.node
};

export { BreakpointsProvider, BreakpointContext, getCurrentBreakpoint };
